import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 group"
          >
            <span className="font-heading text-2xl font-bold text-foreground-900 tracking-tight group-hover:text-primary-500 transition-colors duration-200">
              韩漫在线
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname === "/"
                  ? "text-primary-500"
                  : "text-foreground-700 hover:text-primary-500"
              }`}
            >
              首页
            </Link>
            <div className="relative group">
              <button className="flex items-center gap-1 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                分类
                <i className="ri-arrow-down-s-line w-4 h-4 flex items-center justify-center"></i>
              </button>
              <div className="absolute top-full left-1/2 -translate-x-1/2 pt-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                <div className="bg-background-50 rounded-lg border border-background-200/70 py-2 px-1 shadow-sm min-w-[160px]">
                  {categories.slice(1).map((cat) => (
                    <Link
                      key={cat.id}
                      to={`/category/${cat.slug}`}
                      className="flex items-center gap-2 px-4 py-2 text-sm text-foreground-700 hover:text-primary-500 hover:bg-primary-50 rounded-md transition-colors duration-150 whitespace-nowrap"
                    >
                      <i className={`${cat.icon} w-4 h-4 flex items-center justify-center`}></i>
                      {cat.name}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname === "/about"
                  ? "text-primary-500"
                  : "text-foreground-700 hover:text-primary-500"
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-48 pl-9 pr-4 py-2 text-sm bg-background-100 border border-background-200/70 rounded-full text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-300 transition-all duration-200"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 w-4 h-4 flex items-center justify-center"></i>
            </div>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer"
            aria-label="菜单"
          >
            <i className={`${mobileMenuOpen ? "ri-close-line" : "ri-menu-line"} text-xl w-5 h-5 flex items-center justify-center`}></i>
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden border-t border-background-200/70 bg-background-50">
            <div className="px-4 py-4 space-y-3">
              <Link
                to="/"
                className={`block text-sm font-medium py-2 ${
                  location.pathname === "/"
                    ? "text-primary-500"
                    : "text-foreground-700"
                }`}
              >
                首页
              </Link>
              <div className="text-sm font-medium text-foreground-500 py-2">分类</div>
              <div className="grid grid-cols-2 gap-2">
                {categories.slice(1).map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.slug}`}
                    className="flex items-center gap-2 px-3 py-2 text-sm text-foreground-700 hover:text-primary-500 rounded-md transition-colors"
                  >
                    <i className={`${cat.icon} w-4 h-4 flex items-center justify-center`}></i>
                    {cat.name}
                  </Link>
                ))}
              </div>
              <Link
                to="/about"
                className={`block text-sm font-medium py-2 ${
                  location.pathname === "/about"
                    ? "text-primary-500"
                    : "text-foreground-700"
                }`}
              >
                关于我们
              </Link>
              <div className="relative pt-2">
                <input
                  type="text"
                  placeholder="搜索漫画..."
                  className="w-full pl-9 pr-4 py-2 text-sm bg-background-100 border border-background-200/70 rounded-full text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-300 transition-all"
                />
                <i className="ri-search-line absolute left-3 top-[18px] text-foreground-400 w-4 h-4 flex items-center justify-center"></i>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}